// bolha: realce de sintaxe client-side para blocos de codigo de posts em markdown.
// Usa highlight.js com um subconjunto curado de linguagens (mantem o bundle pequeno
// e a auto-deteccao mais previsivel). O realce roda sobre o DOM ja renderizado.

import hljs from 'highlight.js/lib/core';

import bash from 'highlight.js/lib/languages/bash';
import c from 'highlight.js/lib/languages/c';
import cpp from 'highlight.js/lib/languages/cpp';
import csharp from 'highlight.js/lib/languages/csharp';
import css from 'highlight.js/lib/languages/css';
import diff from 'highlight.js/lib/languages/diff';
import dockerfile from 'highlight.js/lib/languages/dockerfile';
import go from 'highlight.js/lib/languages/go';
import ini from 'highlight.js/lib/languages/ini';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import lua from 'highlight.js/lib/languages/lua';
import makefile from 'highlight.js/lib/languages/makefile';
import markdown from 'highlight.js/lib/languages/markdown';
import nginx from 'highlight.js/lib/languages/nginx';
import perl from 'highlight.js/lib/languages/perl';
import php from 'highlight.js/lib/languages/php';
import plaintext from 'highlight.js/lib/languages/plaintext';
import powershell from 'highlight.js/lib/languages/powershell';
import python from 'highlight.js/lib/languages/python';
import ruby from 'highlight.js/lib/languages/ruby';
import rust from 'highlight.js/lib/languages/rust';
import shell from 'highlight.js/lib/languages/shell';
import sql from 'highlight.js/lib/languages/sql';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';

let registered = false;

function ensureRegistered() {
  if (registered) {
    return;
  }

  hljs.registerLanguage('bash', bash);
  hljs.registerLanguage('c', c);
  hljs.registerLanguage('cpp', cpp);
  hljs.registerLanguage('csharp', csharp);
  hljs.registerLanguage('css', css);
  hljs.registerLanguage('diff', diff);
  hljs.registerLanguage('dockerfile', dockerfile);
  hljs.registerLanguage('go', go);
  hljs.registerLanguage('ini', ini);
  hljs.registerLanguage('java', java);
  hljs.registerLanguage('javascript', javascript);
  hljs.registerLanguage('json', json);
  hljs.registerLanguage('lua', lua);
  hljs.registerLanguage('makefile', makefile);
  hljs.registerLanguage('markdown', markdown);
  hljs.registerLanguage('nginx', nginx);
  hljs.registerLanguage('perl', perl);
  hljs.registerLanguage('php', php);
  hljs.registerLanguage('plaintext', plaintext);
  hljs.registerLanguage('powershell', powershell);
  hljs.registerLanguage('python', python);
  hljs.registerLanguage('ruby', ruby);
  hljs.registerLanguage('rust', rust);
  hljs.registerLanguage('shell', shell);
  hljs.registerLanguage('sql', sql);
  hljs.registerLanguage('typescript', typescript);
  hljs.registerLanguage('xml', xml);
  hljs.registerLanguage('yaml', yaml);

  // Apelidos comuns nao cobertos pelos modulos acima.
  hljs.registerAliases(['yml'], { languageName: 'yaml' });
  hljs.registerAliases(['tf', 'terraform', 'hcl'], { languageName: 'ini' });
  hljs.registerAliases(['toml'], { languageName: 'ini' });

  registered = true;
}

// O formatter de markdown (AdvancedTextFormatter#block_code) grava as quebras
// de linha do bloco de codigo como <br/>. O highlight.js trabalha sobre o
// textContent, que ignora <br>, entao reconstruimos as quebras reais antes.
function normalizeCodeText(block) {
  if (!block.querySelector('br')) {
    return;
  }

  const tmp = document.createElement('div');
  tmp.innerHTML = block.innerHTML.replace(/<br\s*\/?>/gi, '\n');
  block.textContent = tmp.textContent;
}

// Aplica realce em todos os blocos <pre><code> dentro de `node`.
// Idempotente: highlight.js marca os blocos ja processados com
// dataset.highlighted = 'yes'.
export function highlightCodeIn(node) {
  if (!node) {
    return;
  }

  const blocks = node.querySelectorAll('pre code');

  if (blocks.length === 0) {
    return;
  }

  ensureRegistered();

  blocks.forEach((block) => {
    if (block.dataset.highlighted === 'yes') {
      return;
    }

    normalizeCodeText(block);

    // Se veio uma classe language-X mas X nao esta registrado, remove a classe:
    // o highlight.js, com uma linguagem declarada desconhecida, nao coloriria nada;
    // sem a classe ele cai no autodetect.
    const declared = block.className.match(/\blanguage-([\w#+-]+)\b/i);
    if (declared && !hljs.getLanguage(declared[1])) {
      block.classList.remove(`language-${declared[1]}`);
    }

    try {
      hljs.highlightElement(block);
    } catch {
      // Um bloco problematico nao deve derrubar o render do status.
    }
  });
}
